import api from "@/api/axios/axios.js";

export async function getMe() {
  const resp = await api.get("/login/me/");
  return resp.data;
}

export async function getRolesGroups() {
   try {
      const url = `login/roles/`;
      const resp = await api.get(url);
      const data = await resp.data;
      return data
   } catch (err) {
      return "No existe información"
   }
}

export async function getUsers() {
   try {
      const url = `/login/users/`;
      const resp = await api.get(url);
      const data = await resp.data;
      //console.log("777", data)
      return data
   } catch (err) {
      return "No existe información"
   }
}


export async function postRoleUser(userid, roleid) {
   try {
      const url = `/login/roles/asigned/`;
      const resp = await api.post(url, { "user_id": userid, "role_id": roleid });
      const data = await resp.data;
      return data
   } catch (err) {
      //console.log(err)
      return err.response.data.error
   }
}

export async function setActiveUser(userid, active) {
   try {
      const url = `/login/users/status/`;
      const resp = await api.post(url, { "user_id": userid, "active": active });
      const data = await resp.data;
      //console.log("DDDDD ", data)
      return data
   } catch (err) {
      return "No existe información"
   }
}